import { ModalGlass } from "../../components/modal";

export default function ContributionsPage() {
  return (
    <div style={{backgroundImage: "url(https://static.igem.wiki/teams/4260/wiki/imagen/team/contributions/0-contributions-fondo-d-sin-animar-apartado-safety.jpg"}}>
      <div className="h-full w-full py-20 text-white">
        <h1 className="text-7xl cano text-center text-white">CONTRIBUTIONS</h1>
        <div
          className="p-5 mt-5 max-w-4xl m-auto"
          style={{ backgroundColor: "rgba(59, 196, 178,.7)" }}
        >
          <h3 className="text-5xl cano">Overview</h3>
          <p className="p">
            <div align="justify">
              This year iGEM Tec CEM team worked towards the detection and
              degradation of EDCs found in the residual water used to irrigate
              agricultural crops in Mexico, in order to regulate their
              accumulation in plant tissues, hence reducing the consumption of
              EDCs through food.
            </div>
          </p>
          <br></br>
          <h3 className="text-5xl cano">Biosensor</h3>
          <h2 className="text-2xl">
            <b>Software</b>
          </h2>
          <p className="p">
            <div align="justify">
              A wireless biosensor for the measurement of EDCs (Endocrine
              Disruptor Compounds) was developed, allowing unlimited
              accessibility. This way it would not require a fixed power source
              and could be used in the field. Likewise, a Raspberry Pi
              microcontroller was adapted to the device network, which allows us
              to use it as an intermediary to process the signal and send it to
              the PC app. This is possible by working together with the Teensy
              4.1 microcontroller that measures the QCM data. Thus, Teensy
              receives the information and sends it to a physical connection of
              the serial type to Raspberry Pi, which is responsible for
              processing the signal and sends it via Bluetooth to a computer
              through a program that can display the graph of information
              received. For this, several Python codes were developed and
              integrated to the biosensor, in order to adapt it to the Bluetooth
              function and make it work wirelessly; to achieve this it was
              required to know a simple method that filters high frequencies
              called exponential smoothing. Thus, the software can be used by
              other teams and can be improved according to their experiments.
            </div>
            <ul class="list-none" style={{ marginLeft: "30px" }}>
              <li>
                <b>Keywords:</b> Improvement of measurement software.
              </li>
            </ul>
          </p>
          <br></br>
          <h2 className="text-2xl">
            <b>Hardware</b>
          </h2>
          <p className="p">
            <div align="justify">
              A 3D printable hardware was also designed and implemented to
              integrate the piezoelectric transduction that was incorporated to
              the biosensor to capture EDCs. For this, we aimed for the hardware
              to be more compact and for each component to have a specific place
              within it, thus improving the use of space and facilitating the
              interaction between components. One of these improvements was the
              design of the versatile test chamber, so that the QCM (Quartz
              Crystal Microbalance) would have contact with the necessary volume
              of water.
              <br></br>
              Moreover, a PBC was designed and implemented in the biosensor,
              which is a component used to make the electronic circuit and thus
              control the speed of the tests performed.
            </div>
            <ul class="list-none" style={{ marginLeft: "30px" }}>
              <li>
                <b>Keywords:</b> Compact, Versatile, Speed control and
                Improvement of the measurement software.
              </li>
            </ul>
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/contributions/contributions/contributions/figura1dise-ofinalbioseonsor-contributions-removebg-preview.png"
            alt=" Figura1"
            className="figure"
            style={{ maxWidth: 300 }}
          />
          <p className="figure_desc">
            <b>Figure 1.</b>
            <i>
              Biosensor final design with modifications implemented regarding
              the model made by <b>Tec CEM 2022 team</b>.
            </i>
          </p>
          <br></br>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/contributions/contributions/contributions/figura2-diagrama-de-biosenor-ingl-s.jpg"
            alt=" Figura1"
            className="figure"
            style={{ maxWidth: 300 }}
          />
          <p className="figure_desc">
            <b>Figure 2.</b>
            <i>
              Diagram of contributions implemented as part of the Biosensor
              designed by <b>Tec CEM 2022 team</b>.
            </i>
          </p>
          <h3 className="text-5xl cano">Degradation</h3>
          <h2 className="text-2xl">
            <b>Laccases</b>
          </h2>
          <p className="p">
            <div align="justify">
              The first laccase is called 15A, it originated from the bacterium
              Thermus thermophilus, which was designed from the
              Bielefeld-Germany 2004 team. Tec CEM 2021 team contributed to its
              characterization with dye degradation assays. On the other hand,
              this year we (Tec CEM 2022) increased the characterization to
              evaluate the enzymatic activity of laccase with dye degradation
              assays with other substrates, such as Guaiacol; this is a
              substrate that laccase degrades and when it is degraded it has a
              fast colorimetric reaction to be seen, since its reaction is
              faster than with other dyes. These assays determined the
              functionality of laccase, due to a methodology required to be able
              to follow up the enzymatic activity immobilized in zeolite.
              <br></br>
              Functionality tests were carried out with commercial laccase,
              after verifying the efficiency of this protocol, the laccase
              (LAC_TV_HD22) made by Tec CEM 2022 was used. These assays were
              performed with Malachite Green, in which laccase degrades the
              colorant, and with Guaiacol, in which laccase oxidizes the
              substrate and a colorimetric change is observed. Both assays
              evaluate the functionality of the enzyme and, despite the
              difference in mechanisms, it was confirmed that they fulfill the
              same function and provide equivalent results.
              <br></br>
              The second laccase used comes from Trametes versicolor, this one
              has a high degradation efficiency and was made with the coding
              region of the UCL_London 2012 team (BBa_K729002), as it was taken
              and redesigned with a new promoter (BBa_J64997), terminator
              (BBa_K395601) and histidine tag (BBa_K1223006), this new version
              was called Trametes versicolor Hydro defense 2022 (LAC_TV_HD22).
              <br></br>
              For this new version it was observed that the active site of the
              laccase binds and degrades the nickel in the column making this
              methodology inefficient. This was verified by what was mentioned
              in the Degradation Results section.
              <br></br>
              Finally, in this new version of laccase a signal peptide called
              OmpA was added, it was decided to place this peptide because in
              several studies such as that of Takahara, M. et al. 1985, it is
              mentioned that it would be in charge of carrying the translation
              of the protein to the periplasm of E. coli, and prevent the
              protein from being insoluble [1].
              <br></br>
              In addition, a characterization of our Tec CEM 2022 LAC_TV_HD22
              construct was performed. This characterization documents
              information on the modeling performed in iTASSER, such as its
              morphology, its interaction between the linker and the lacasse,
              the conditions for its optimal operation, and the fact of
              providing information to other iGEM users and/or teams that need
              to use the construct in their project.
            </div>
            <br></br>
            <h2 className="text-2xl">
              <b>Mathematical modeling</b>
            </h2>
          </p>
          <p className="p">
            <div align="justify">
              Degradation modeling was performed to quantify the EDCs of the
              biosensor using the BIBI Pinpong complex enzyme model, this model
              determines the laccase activity, for this reason the
              Michaelis-Menten model was not used because laccase has a specific
              reaction mechanism. This tool allows the scientific community,
              other iGEM teams and others interested in obtaining the kinetic
              activity of laccase. It is aimed to be used as a calculator as a
              tool for education, this with a shareable Matlab code.<br></br>
              In the same way it serves to calibrate the equation with the
              experimental results and decide the amount of enzyme to use, so
              the measurements would allow a greater efficiency without loss of
              reagents and experimental time. The objective of this is to use it
              as a calculator as a tool for education, this with a Matlab code
              that can be shared.
            </div>
            <ul class="list-none" style={{ marginLeft: "30px" }}>
              <li>
                <b>Keywords:</b> Laccase construction improvement, construct
                characterization, enzyme activity evaluation, purification
                protocol.
              </li>
            </ul>
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/contributions/contributions/contributions/image3.png"
            alt=" Figura1"
            className="figure"
            style={{ maxWidth: 300 }}
          />
          <p className="figure_desc">
            <b>Figure 3.</b>
            <i>
              Diagram of contributions implemented as part of the Biosensor
              designed by <b>Tec CEM 2022 team</b>.
            </i>
          </p>
          <br></br>
        </div>
        <br></br>
        <h2 className="text-2xl max-w-xl m-auto">
              <b>References</b>
            </h2>
          <p className="p max-w-2xl m-auto"><p className="p"></p>
            
            <ul style={{marginLeft: "30px" }}>
              <li>
              [1] Takahara, M., Hibler, D. W., Barr, P. J., Gerlt, J. A., & Inouye, M. (1985). The ompA signal peptide directed secretion of Staphylococcal nuclease A by Escherichia coli. Journal of Biological Chemistry, 260(5), 2670–2674. doi:10.1016/s0021-9258(18)89413-3 
              </li>
            </ul>
          </p>
      </div>
    </div>
  );
}
